import {getMethod} from '~/api'

async function get(id) {
    return await getMethod(`/api/kpiStatistics/${id}`)
}

export {get}
